import { generationRuleItems } from "../GenerationRule/generation-rule.mock";
import { IListsGeneration } from "./models";

export const listGeneration: IListsGeneration[] = [
  {
    id: "100",
    name: "Primeira lista",
    generationRule: generationRuleItems[0],
  },
  {
    id: "101",
    name: "Segunda lista",
    generationRule: generationRuleItems[1],
  },
  {
    id: "102",
    name: "Terceira lista",
    generationRule: generationRuleItems[0],
  },
];
